import React, { useState, useEffect } from 'react';
import DocumentListMobile from './documentListMobile';
import DocumentListWeb from './documentListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const DocumentListRouter = (props) => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  if (width === 0) {
    return null;
  }

  return width < MOBILE_BREAKPOINT ? (
    <DocumentListMobile {...props} />
  ) : (
    <DocumentListWeb {...props} />
  );
};

export default DocumentListRouter;
